import styled from 'styled-components'
import { StyledColItem } from 'components/SectionHandler'

export const SectionContainer = styled.div`
	margin-top: 10px;
	div${StyledColItem} {
		max-width: none;
	}
`
